import config from "../config/application"
import { apiCall } from "./common/base.service"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"

const notificationEmail = "find"
const area = "area"
const save = "register"
const delete_notificationEmail = "delete"
const edit = "update"
const sendEmail = "sendEmail"

class NotificationEmailService {

  getStatusOrder = async () => {
    const url = `${config.data.providers.notificationEmail.url}${area}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await notificationEmailService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("get", url)
  }

  getNotificationsEmail = async filter => {
    const url = `${config.data.providers.notificationEmail.url}${notificationEmail}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await notificationEmailService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, filter)
  }

  async saveNotificationEmail(json) {
    const requests = json.area.map(status => {
      const jsonCopy = { ...json };
      jsonCopy.area = status;
      return apiCall("post", `${config.data.providers.notificationEmail.url}${save}`, jsonCopy);
    });
    if (requests.length > 1) {
      const responses = await Promise.all(requests);
      return responses;
    }
    return requests[0];
  }

  async editNotificationEmail(notificationEmail) {
    const url = `${config.data.providers.notificationEmail.url}${edit}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await notificationEmailService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.edit
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("put", url, notificationEmail)
  }

  async deleteNotificationEmail(notificationEmailList) {
    const url = `${config.data.providers.notificationEmail.url}${delete_notificationEmail}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await notificationEmailService.getPermissions(userAux.id.user.username, dictionary.configApp.action.delete)
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("delete", url, notificationEmailList)
  }

  async sendNotificationEmail(json) {
    const url = `${config.data.providers.notificationEmail.url}${sendEmail}`

    return apiCall("put", url, json)
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_NOTIFICATIONS,
      username,
      process.env.REACT_APP_SYSTEM_CODE, action);
  }

}

const notificationEmailService = new NotificationEmailService()
export default notificationEmailService